import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { healthDevicesAPI } from '../../lib/api';
import { SpinnerGap } from '@phosphor-icons/react';
import { toast } from 'sonner';

export default function DexcomCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Connecting your Dexcom...');
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const code = params.get('code');
    const state = params.get('state');
    if (!code || !state) {
      toast.error(params.get('error') ? 'Dexcom connection was cancelled' : 'Missing Dexcom authorization');
      navigate('/patient/health-devices', { replace: true });
      return;
    }
    healthDevicesAPI.dexcomCallback(code, state)
      .then((res) => {
        toast.success(`Dexcom connected. ${res.data.readings_imported || 0} readings imported.`);
      })
      .catch((err) => {
        toast.error(err.response?.data?.detail || 'Could not connect Dexcom');
        setMessage('Connection failed');
      })
      .finally(() => navigate('/patient/health-devices', { replace: true }));
  }, [params, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] gap-3" data-testid="dexcom-callback-page">
      <SpinnerGap size={32} className="animate-spin text-teal-600" />
      <p className="text-slate-600">{message}</p>
    </div>
  );
}
